/**
 * Labstep
 *
 * @module components/Device/Action/Menu
 * @desc Action Menu for Device
 */

import { DeviceActionDelete } from 'labstep-web/components/Device/Action/Delete';
import { DeviceActionDuplicate } from 'labstep-web/components/Device/Action/Duplicate';
import { DeviceActionShare } from 'labstep-web/components/Device/Action/Share';
import { DeviceActionUpdateTemplate } from 'labstep-web/components/Device/Action/UpdateTemplate';
import EntityActionRevoke from 'labstep-web/components/Entity/Action/Revoke';
import { EntityActionTag } from 'labstep-web/components/Entity/Action/Tag';
import { EntityActionTransferOwnership } from 'labstep-web/components/Entity/Action/TransferOwnership';
import { EntityUserActionManage } from 'labstep-web/components/EntityUser/Action/Manage';
import { ActionMenu as ActionsMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { DeviceActionMenuProps } from './types';

export enum Action {
  view = 'view',
  share = 'share',
  duplicate = 'duplicate',
  tag = 'tag',
  delete = 'delete',
  assign = 'assign',
  revoke = 'revoke',
  transfer_ownership = 'transfer_ownership',
  set_template = 'set_template',
}

export const DeviceActionMenu: React.FC<DeviceActionMenuProps> = ({
  device,
  type,
  actions = [],
}) => {
  return (
    <ActionsMenu type={type}>
      {actions.includes(Action.tag) && (
        <EntityActionTag parentEntity={device} />
      )}
      {actions.includes(Action.share) && (
        <DeviceActionShare device={device} />
      )}
      {actions.includes(Action.duplicate) && (
        <DeviceActionDuplicate device={device} />
      )}
      {actions.includes(Action.revoke) && (
        <EntityActionRevoke entity={device} />
      )}
      {actions.includes(Action.assign) && (
        <EntityUserActionManage entity={device} />
      )}
      {actions.includes(Action.set_template) && (
        <DeviceActionUpdateTemplate device={device} />
      )}
      {actions.includes(Action.transfer_ownership) && (
        <EntityActionTransferOwnership entity={device} />
      )}
      {actions.includes(Action.delete) && (
        <DeviceActionDelete device={device} />
      )}
    </ActionsMenu>
  );
};

DeviceActionMenu.defaultProps = {
  actions: [],
  type: 'icon',
};
